/** Shared builder form fields + empty state for Add / Edit screens */

export const emptyBuilderForm = () => ({
  companyName: '',
  legalName: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  defaultCommissionPercent: '',
  commissionAgreementNotes: '',
  contactsJson: '',
  documentsJson: '',
});

export const fld = { display: 'flex', flexDirection: 'column', gap: 4 };
export const lbl = { fontSize: 11, fontWeight: 700, color: '#8898aa', textTransform: 'uppercase' };
export const inp = {
  padding: '10px 14px',
  borderRadius: 9,
  border: '1px solid #e3e6ec',
  fontSize: 14,
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
};
export const section = (color) => ({
  background: '#fff',
  borderRadius: 14,
  boxShadow: '0 2px 12px rgba(0,0,0,.06)',
  padding: 22,
  marginBottom: 18,
  borderTop: `3px solid ${color}`,
});

export function BuilderFormFields({ form, set }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 14 }}>
      <div style={fld}>
        <label style={lbl}>Company name *</label>
        <input style={inp} value={form.companyName} onChange={(e) => set('companyName', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>Legal name</label>
        <input style={inp} value={form.legalName} onChange={(e) => set('legalName', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>Email</label>
        <input style={inp} type="email" value={form.email} onChange={(e) => set('email', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>Phone</label>
        <input style={inp} value={form.phone} onChange={(e) => set('phone', e.target.value)} />
      </div>
      <div style={{ ...fld, gridColumn: '1 / -1' }}>
        <label style={lbl}>Address</label>
        <input style={inp} value={form.address} onChange={(e) => set('address', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>City</label>
        <input style={inp} value={form.city} onChange={(e) => set('city', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>State</label>
        <input style={inp} value={form.state} onChange={(e) => set('state', e.target.value)} />
      </div>
      <div style={fld}>
        <label style={lbl}>Default commission %</label>
        <input
          style={inp}
          type="number"
          step="0.01"
          placeholder="e.g. 3"
          value={form.defaultCommissionPercent}
          onChange={(e) => set('defaultCommissionPercent', e.target.value)}
        />
      </div>
      <div style={{ ...fld, gridColumn: '1 / -1' }}>
        <label style={lbl}>Agreement notes</label>
        <textarea
          rows={3}
          style={{ ...inp, resize: 'vertical' }}
          value={form.commissionAgreementNotes}
          onChange={(e) => set('commissionAgreementNotes', e.target.value)}
        />
      </div>
      <div style={fld}>
        <label style={lbl}>Contacts JSON</label>
        <input
          style={inp}
          placeholder='[{"name":"","role":"","phone":"","email":""}]'
          value={form.contactsJson}
          onChange={(e) => set('contactsJson', e.target.value)}
        />
      </div>
      <div style={fld}>
        <label style={lbl}>Documents JSON</label>
        <input style={inp} value={form.documentsJson} onChange={(e) => set('documentsJson', e.target.value)} />
      </div>
    </div>
  );
}

export function toBuilderDto(clientId, form, editingId) {
  const dto = {
    clientId,
    companyName: form.companyName.trim(),
    legalName: form.legalName || null,
    email: form.email || null,
    phone: form.phone || null,
    address: form.address || null,
    city: form.city || null,
    state: form.state || null,
    defaultCommissionPercent:
      form.defaultCommissionPercent === '' ? null : Number(form.defaultCommissionPercent),
    commissionAgreementNotes: form.commissionAgreementNotes || null,
    contactsJson: form.contactsJson || null,
    documentsJson: form.documentsJson || null,
  };
  if (editingId) dto.id = editingId;
  return dto;
}
